<script>
  import { Advantages, PartnersSlider, store, imgSrc } from '$client';
  import About from './about.svelte';
  const { other, city } = store;
  export let data;
  $: about = data.about;
  $: catalogs = data.catalogs;
</script>

<section id="main" class="margin-top">
  <About data={about.about} {catalogs} />
  <section class="container advantages">
    <h2 class="h2">{about.advantages.header}</h2>
    <Advantages data={about.advantages.data} />
  </section>
  <PartnersSlider data={$other.partners.data} />
  <section class="container contact-block">
    <h2>Контакты</h2>
    <address>
      {#each $city.block as address}
        <div>
          <img src={imgSrc(address.img.data.attributes.url)} alt={address.img.data.attributes.alternativeText} />
          {#if address.href}
            <a class="color-button" href={address.href}>{address.header}</a>
          {:else}
            <span>{address.header}</span>
          {/if}
        </div>
      {/each}
    </address>
  </section>
  <section class="container" id="requisite">
    <h2 class="h2">{about.requisites.header}</h2>
    <address>{@html about.requisites.data.replaceAll('\n', '<br/>')}</address>
  </section>
</section>

<style lang="scss">
  .advantages {
    padding-block: 50px;
    background-color: #f6f7f8;
  }

  .advantages h2 {
    margin-bottom: 50px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
  }

  #requisite {
    width: 100%;
    font-size: 18px;
    font-family: Roboto;
    padding-block: 50px;

    h2 {
      margin-bottom: 50px;
      color: #2c333c;
      font-weight: 800;
      font-size: 36px;
      font-family: Vela Sans;
    }

    address {
      display: inline-flex;
      flex-wrap: wrap;
      gap: 24px;
      width: 100%;
      color: #2c333c;
      font-weight: normal;
      font-size: 18px;
      font-family: Roboto, sans-serif;
      line-height: 25px;

      a,
      span {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 12px;
        align-items: center;
        justify-content: center;
        color: #2c333c;
      }
    }
  }

  .contact-block {
    width: 100%;
    font-size: 18px;
    font-family: Roboto;
    background-color: #f6f7f8;
    padding-block: 50px;

    h2 {
      margin-bottom: 50px;
      color: #2c333c;
      font-weight: 800;
      font-size: 36px;
      font-family: Vela Sans;
    }

    address {
      display: inline-flex;
      flex-wrap: wrap;
      gap: 24px;
      width: 100%;

      div {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 12px;
        align-items: center;
        justify-content: center;
        color: #2c333c;
      }

      a,
      span {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 12px;
        align-items: center;
        justify-content: center;
        color: #2c333c;
      }
    }
  }
</style>
